// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import MainLayout from '../../layouts/MainLayout';
import Row from '../../components/Row';
import Column from '../../components/Column';
import Button from '../../components/Button';
import CollapseTransition from '../../components/CollapseTransition';
import ChallengeErrorForbiddenImage from '../../assets/images/lab-error-forbidden.svg';
import ChallengeTimeIcon from '../../assets/images/lab-time-icon.svg';
import ExamECVLogoImage from '../../assets/images/exam-ecv-logo.svg';

import { getColor } from '../../styled/color';
import WorkshopLabel from './components/WorkshopLabel';
import Navigation from './components/Navigation';
import CreditNotion from './components/CreditNotion';

export const S = {
  MainLayout: styled(MainLayout)<{ examStart: boolean }>`
    user-select: none;
    ${props => props.examStart ? { background: '#E7E7E7' } : null};
  `,
  Container: styled(Row) <{ inWorkshop: boolean, examStart: boolean }>`
    padding: 24px;
    ${props => props.inWorkshop ? { paddingTop: '69px' } : null};
    ${props => props.examStart ? `
      background: #FFFFFF;
      margin: 5% 3%;
      position: relative;
    ` : null};
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
  `,
  NavigationContainer: styled.div<{ inWorkshop: boolean }>`
    display: flex;
    flex-direction: column;
    width: 200px;
    top: ${props => props.inWorkshop ? 'calc(70px + 17px)' : 'calc(70px + 24px)'};
    left: 32px;
    bottom: 0;
    overflow: visible;
    position: fixed;
    transition: bottom 0.5s ease-in;
  `,
  WorkshopLabel: styled(WorkshopLabel)`
    flex-shrink: 0;
    padding-left: 0;
    margin-bottom: 27px;
    position: absolute;
    top: 100px;
  `,
  Navigation: styled(Navigation)`
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */

    &::-webkit-scrollbar { /* WebKit */
      width: 0;
      height: 0;
    }
  `,
  WrapperContent: styled.div<{ examStart: boolean }>`
    overflow-y: ${props => props.examStart ? 'visible' : 'auto'};
    width: 100%;
    margin-left: 100px;
    margin-right: 310px;
    ${props => props.examStart ? `
      margin: 33px 60px 77px 56px;
    ` : null};
  `,
  CollapseTransition: styled(CollapseTransition)`
    overflow: visible;
  `,
  WrapperSidebar: styled.div<{ inWorkshop: boolean, examStart: boolean }>`
    width: 230px;
    right: 32px;
    top: ${props => props.inWorkshop ? 'calc(70px + 69px)' : 'calc(70px + 24px)'};
    position: fixed;
    ${props => props.examStart ? `
      position: initial;
      width: 330px;
      margin-top: 30px;
    ` : null};
  `,
  StartStopContainer: styled(Column)`
    align-items: center;
    padding: 14px;
    background: ${getColor('White2')};
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    position: relative;
  `,
  ConfirmStartContainer: styled.div`
    position: absolute;
    border-radius: 4px;
    left :0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 18px 14px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    opacity: 0;
    transition: 0.5s;
    background-color: rgba(0,0,0,0.8);

    &:hover {
      opacity: 1;
    }
  `,
  ConfirmStartTitle: styled.p`
    white-space: nowrap;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    color: white;
  `,
  TimerDurationText: styled.span`
    font-size: 28px;
    color: #666666;
  `,
  StartButton: styled(Button)`
    margin-top: 5px;
    width: 100%;
  `,
  DescriptionContainer: styled.div`
    padding: 24px 14px;
  `,
  CreditAmount: styled.span`
    display: flex;
    align-items: baseline;
    color: ${getColor('Orange')};
    font-size: 24px;
  `,
  Credit: styled.span`
    color: ${getColor('Orange')};
    font-size: 36px;
    margin-right: 3px;
  `,
  CreditNotion: styled(CreditNotion)`
    margin-bottom: 3px;
    margin-left: 8px;
  `,
  DescriptionText: styled.div`
    color: #666666;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 24px;
    word-break: break-word;
  `,
  DescriptionCreditText: styled.span`
    font-size: 16px;
    color: ${getColor('Orange')};
    margin: 0 7px;
  `,
  DescriptionEmailText: styled.a`
    font-size: 16px;
    color: #828E8E;
    text-decoration-line: underline;
    cursor: pointer;
  `,
  LinkButton: styled(Button)`
    margin-top: 5px;
    width: 100%;
    text-align: center;
    height: 58px;
  `,
  ExamName: styled.div`
    font-weight: 700;
    font-size: 32px;
    color: #666666;
    line-height: 46px;
    margin-bottom: 80px;
  `,
  ECVLogoContainer: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  `,
  ECVLogoImage: styled.img.attrs({ src: ExamECVLogoImage })`
    max-width: 80px;
    margin-bottom: 40px;
  `,
  OverviewTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    color: #434343;
    line-height: 35px;
    margin-bottom: 20px;
  `,
  OverviewText: styled.div`
    font-size: 16px;
    color: #666666;
    line-height: 23px;
    margin-bottom: 20px;
  `,
  ChallengeErrorContainer: styled(Column)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
  `,
  ChallengeErrorForbiddenImage: styled.img.attrs({ src: ChallengeErrorForbiddenImage })`
    width: 335px;
  `,
  ErrorText: styled.div`
    font-size: 18px;
    line-height: 30px;
    margin-top: 19px;
    margin-bottom: 32px;
    color: #313131;
  `,
  ErrorButton: styled(Button)`
    min-width: 142px;
    font-size: 18px;
    padding: 0 14px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  `,
  ExamNavigationTitle: styled.p`
    font-size: 18px;
    margin-top: 30px;
    color: #646464;
  `,
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.31);
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  QuestionnaireContainer: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    width: 70%;
  `,
};
